import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownCharterServiceCategories', request)
}

async function post(request) {
    return await postMethod('/api/ownCharterServiceCategories', request)
}

async function put(request) {
    return await putMethod('/api/ownCharterServiceCategories', request)
}

export {get, post, put}
